import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import commonActions from '../../Actions/commonActions'
import leadActions from '../../Actions/leadActions'

import Modal from '../../Components/Modal'
import TextInput from '../../Components/TextInput'

class AoBuyModal extends Component {

    componentDidMount() {
        const { leadActions} = this.props;
        leadActions.startBuyModalAo(this.getModel())
    }

    getModel() {
        return {
            reason: 'Buy',
            action:'Close',
            amount: 0
        }
    }

    handleFieldChange = (field, value) => {
        const { commonActions, form: { id: formId } } = this.props;
        commonActions.changeMultiFormField(formId, field, value);
    }

    handleClickSave = () => {
        const { leadActions, lead, form, onSave, leadType} = this.props;

        leadActions.close(lead.id, form, leadType, onSave)
    }

    handleClickClose = () => {
        this.props.onClose();
    }

    onFormSubmit = e => {
        e.preventDefault();
        this.handleClickSave();
    }


    render() {
        const {form} = this.props;

        if(!form ) {
            return null;
        }

        const modalProps = {
            title: `Buy`,
            mainButtonTitle: "Save",
            onCancelClick: this.handleClickClose,
            stateful: true,
            open: true,
            onSaveClick: this.handleClickSave
        }

        return (
            <Modal {...modalProps}>
                <form className='form-horizontal col-xs-10'  onSubmit={this.onFormSubmit}>
                    <TextInput label="Amount *" type={"number"} onChange={this.handleFieldChange.bind(this, 'amount')} value={form.data.amount} />
                    <TextInput label="Message" multiline={true} onChange={this.handleFieldChange.bind(this, 'message')} value={form.data.message}/>
                    <div className="clearfix"></div>
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        reasonCodes: state.CommonReducer.dropdownlists && state.CommonReducer.dropdownlists.LeadsBuyReasonCodes,
        form: state.CommonReducer.forms && state.CommonReducer.forms.leadBuyModalAo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        leadActions: bindActionCreators(leadActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AoBuyModal);
